import { render, staticRenderFns } from "./bunk.vue?vue&type=template&id=60953a89&"
import script from "./bunk.vue?vue&type=script&lang=js&"
export * from "./bunk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports